import { render } from "./comprehensiveEvaluation.vue?vue&type=template&id=28c209d2&scoped=true"
import script from "./comprehensiveEvaluation.vue?vue&type=script&lang=js"
export * from "./comprehensiveEvaluation.vue?vue&type=script&lang=js"

import "./comprehensiveEvaluation.vue?vue&type=style&index=0&id=28c209d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c209d2"]])

export default __exports__